import { useEffect, useMemo, useState } from "react";
import { useHttpGets } from "../../../services/httpService";
import { ApiEndPoints } from "../../../utils/endpoints";
import { MEMBER_KEY, USER_DETAIL } from "../../../utils/constants";
import { REIDropDown, REIProgressSpinner } from "../../../components/ui";
import ContactDetails from "../MyProperty/ContactDetails";
import { fetchFormattedAddress } from "../../../utils/commonUtil";

const MyPhoneBook: React.FC = () => {
  const memberDetail = useMemo(() => JSON.parse(localStorage.getItem(USER_DETAIL) || "{}"), []);
  const memberId = localStorage.getItem(MEMBER_KEY) || "";
  const [properties, setProperties] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [selectedProperty, setSelectedProperty] = useState<number>(-1); // Default to "All Properties"
  const [isLoading, setIsLoading] = useState(false);

  const onPropertyChange = (e: { value: number }) => {
    setSelectedProperty(e.value);
  };

  useEffect(() => {
    setIsLoading(true);
    useHttpGets(
      `${ApiEndPoints.tracker}/PortfolioTracker/MyProperties?MemberId=${memberId}&userCountryCode=${memberDetail.Country}`
    )
      .then((result) => {
        if (result?.data != null && !result.error) {
          setData(result.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error loading properties:", error);
      });
  }, [memberId]);

  useEffect(() => {
    if (data.length > 0) {
      let propertyOptions: any[] = [];
      data.forEach((item: any) => {
        const baseAddress = [item.StreetAddress, item.Suburb, item.State, item.Postcode].filter(Boolean).join(", ");
        if (!baseAddress) return;

        const apiKey = process.env.GOOGLE_MAPS_API_KEY;
        if (apiKey) {
          fetchFormattedAddress(baseAddress, apiKey).then((formatted) => {
            propertyOptions.push({
              label: formatted || baseAddress,
              value: item.PortfolioTrackerId,
            });
            if (propertyOptions.length === data.length) {
              setProperties([
                { label: "General Contact", value: 0 },
                ...propertyOptions,
                { label: "All Contacts", value: -1 },
              ]);
            }
          });
        } else {
          propertyOptions.push({
            label: baseAddress,
            value: item.PortfolioTrackerId,
          });
        }
      });

      propertyOptions = [{ label: "General Contact", value: 0 }, ...propertyOptions];
      propertyOptions = [{ label: "All Contacts", value: -1 }, ...propertyOptions];

      setProperties(propertyOptions);

      if (propertyOptions.length > 0 && selectedProperty === null) {
        setSelectedProperty(-1);
      }
    } else {
      setProperties([{ label: "General Contact", value: 0 }]);
    }
  }, [data, selectedProperty]);

  return (
    <div className="flex flex-col">
      {isLoading ? (
        <div className="flex justify-center items-center min-h-[200px]">
          <REIProgressSpinner />
        </div>
      ) : (
        <>
          <div className="flex flex-row flex-wrap mb-2">
            <label className="self-center mr-3" htmlFor="property">
              Property address:
            </label>
            <REIDropDown
              id="mpb-drop-property"
              key={`property-${selectedProperty}`}
              value={selectedProperty}
              data={properties}
              label="label"
              onSelectionChange={(e) => onPropertyChange(e)}
              placeholder="Select Property"
              className="w-min"
            />
          </div>
          <ContactDetails propertyTrackerId={selectedProperty === -1 ? -1 : selectedProperty} properties={properties} />
        </>
      )}
    </div>
  );
};

export default MyPhoneBook;
